// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import { Link, browserHistory } from 'react-router';
import api, { defaultRejectionHandler } from 'utils/api';
import { Page } from 'shared/containers/portal_layout';
import Modal from 'shared/components/Modal';
import LoadingContent from 'shared/components/LoadingContent';
import QuickAssignOrSchedule from 'shared/components/Referrals/QuickAssignOrSchedule';
import ChooseWarning from 'shared/components/Referrals/ChooseWarning';
import FileUploader from 'shared/components/Referrals/FileUploader';
import AppointmentCanceller from 'shared/components/Referrals/AppointmentCanceller';
import AppointmentNoShower from 'shared/components/Referrals/AppointmentNoShower';
import ReferralWithdrawer from 'shared/components/Referrals/ReferralWithdrawer';
import ReferralExhauster from 'shared/components/Referrals/ReferralExhauster';
import ReferralChecklist from 'shared/components/Referrals/ReferralChecklist';
// import CommentForm from 'shared/components/Referrals/CommentForm';
import { CommentForm } from './CommentForm';
import ReferralEvent from 'shared/components/Referrals/ReferralEvent';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Icon from 'shared/components/Icon';
import ShowFile from 'shared/components/ShowFile';
import ReferralQuestionnaire from 'shared/components/Referrals/ReferralQuestionnaire';
import PromiseButton from 'shared/components/PromiseButton';
import ReferralReminderCreator from 'shared/components/Referrals/ReferralReminderCreator';
import { ReasonForDelayForm } from 'shared/components/Referrals/ReasonForDelayForm';
import PatientCoverageDetails from 'shared/components/PatientCoverageDetails';
import ReferralsActions from 'agent_portal/actions/ReferralsActions';
import * as IncidentalFindings from '../IncidentalFindings';
import StatusBadge from './StatusBadge';
import AppointmentStatusBadge from './AppointmentStatusBadge';
import ReferralProviderCard from './ReferralProviderCard';
import Reminders from './Reminders';
import Tooltip from '../Tooltip';
import styles from './ReferralsShow.module.scss';
import { UpdateSpecialtyForm } from '../UpdateSpecialtyForm';
import { AssignAgentForm } from '../AssignAgentForm';
import { RejectReferralModal } from '../RejectReferralModal';
import { CompleteAppointmentButton } from '../CompleteAppointmentButton';
import { UncompleteAppointmentButton } from '../UncompleteAppointmentButton';

class Show extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      referral: null,
      editPatientPath: null,
      patient: null,
      appointment: null,
      fetchingId: null,
      openModal: null,
      options: null,
      hideStaleContent: false,
    };
    this.hideModal = this.hideModal.bind(this);
    this.handleSuccessfulModalAction = this.handleSuccessfulModalAction.bind(
      this
    );
    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.handlePatientConfirmClick = this.handlePatientConfirmClick.bind(this);
    this.deleteFileAttachmentMapping = this.deleteFileAttachmentMapping.bind(
      this
    );
    this.handleChooseClick = this.handleChooseClick.bind(this);
    this.refresh = this.refresh.bind(this);
    this.acknowledgeIncidentalFindings = this.acknowledgeIncidentalFindings.bind(
      this
    );
    this.handleSuccessfulSchedule = this.handleSuccessfulSchedule.bind(this);
    this.handleSuccessfulAssignOrSchedule = this.handleSuccessfulAssignOrSchedule.bind(
      this
    );
    this.markReminderComplete = this.markReminderComplete.bind(this);
    this.markReminderIncomplete = this.markReminderIncomplete.bind(this);
    this.deleteReminder = this.deleteReminder.bind(this);
    this.handleResendAppointmentText = this.handleResendAppointmentText.bind(
      this
    );
    this.unassignAgent = this.unassignAgent.bind(this);
  }

  componentDidMount() {
    this.fetchReferral(this.props.params.referralId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.referralId !== this.props.params.referralId) {
      this.setState({ hideStaleContent: true });
      this.fetchReferral(this.props.params.referralId);
    }
  }

  showModal(name) {
    this.setState({ openModal: name });
  }

  hideModal() {
    this.setState({ openModal: null });
  }

  handleSuccessfulModalAction() {
    this.hideModal();
    this.refresh();
  }

  handleSuccessfulSchedule(transferredToId) {
    if (transferredToId) {
      this.hideModal();
      browserHistory.push(
        `${this.props.webpageBase}/referrals/${transferredToId}`
      );
    } else {
      this.handleSuccessfulModalAction();
    }
  }

  handleSuccessfulAssignOrSchedule(referralId) {
    if (referralId && referralId !== this.props.params.referralId) {
      // Referral was transferred, so we have a new referral id
      this.hideModal();
      browserHistory.push(`${this.props.webpageBase}/referrals/${referralId}`);
    } else {
      this.handleSuccessfulModalAction();
    }
    // console.log("WIP THIS NEEDS TO BE IMPLEMENTED");
  }

  refresh(hideStaleContent = false) {
    if (hideStaleContent) {
      this.setState({ hideStaleContent: true });
    }
    this.fetchReferral(this.props.params.referralId);
    if (this.state.options.shouldFetchPendingReferralsCount) {
      this.fetchPendingReferralsCount();
    }
  }

  acknowledgeIncidentalFindings() {
    return api
      .post(
        `${this.props.apiEndpoint}/referrals/${this.props.params.referralId}/incidental_finding/acknowledgements`,
        {
          lock_version: this.state.referral.incidentalFinding.lockVersion,
        }
      )
      .then(
        (response) => {
          FlashMessageActions.flashSuccess({
            message: 'You have acknowledged the incidental findings',
          });
          this.refresh();
          return null;
        },
        (error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errorCode === 'stale'
          ) {
            this.refresh(true);
            FlashMessageActions.flashWarning({
              message:
                'Oops, the report was recently updated. Please review the latest report below and reacknowledge it.',
              sticky: true,
            });
            return null;
          } else {
            return defaultRejectionHandler(error);
          }
        }
      );
  }

  handleConfirmClick() {
    return api
      .post(
        `${this.props.apiEndpoint}/appointments/${this.state.appointment.id}/confirmation`
      )
      .then((response) => {
        FlashMessageActions.flashSuccess({
          message: 'You have confirmed the appointment',
        });
        this.refresh();
      });
  }

  handlePatientConfirmClick() {
    return api
      .post(
        `${this.props.apiEndpoint}/appointments/${this.state.appointment.id}/patient_confirmation`
      )
      .then((response) => {
        FlashMessageActions.flashSuccess({
          message: 'You have confirmed the appointment',
        });
        this.refresh();
      });
  }

  handleChooseClick() {
    if (this.state.referral.active && this.state.referral.hasOrganization) {
      this.showModal('choose');
    } else {
      browserHistory.push(
        `${this.props.webpageBase}/referral_profiles/${this.state.referral.referralProfileId}/referral_dashboard`
      );
    }
  }

  fetchReferral(referralId) {
    this.setState({ fetchingId: referralId });
    api
      .get(`${this.props.apiEndpoint}/referrals/${referralId}`)
      .then((response) => {
        if (referralId === this.state.fetchingId) {
          this.setState({
            hideStaleContent: false,
            fetchingId: null,
            referral: response.data.referral,
            editPatientPath: response.data.editPatientPath,
            creatorName: response.data.creatorName,
            createdOn: response.data.createdOn,
            patient: response.data.patient,
            appointment: response.data.appointment,
            options: response.data.options,
          });
        }
      });
  }

  fetchPendingReferralsCount() {
    api
      .get(`${this.props.apiEndpoint}/referrals/pending_count`)
      .then((response) => {
        ReferralsActions.updatePendingReferralsCount({
          pendingReferralsCount: response.data.pendingReferralsCount,
        });
      });
  }

  deleteFileAttachmentMapping(id) {
    /* eslint-disable no-alert */
    if (window.confirm('Are you sure you want to delete this file?')) {
      return api
        .delete(`${this.props.apiEndpoint}/file_attachment_mappings/${id}`)
        .then((response) => {
          FlashMessageActions.flashSuccess({
            message: 'You have deleted a file',
          });
          this.refresh();
        });
    }
    return null;
    /* eslint-enable no-alert */
  }

  markReminderComplete(reminderId) {
    return api
      .put(
        `${this.props.apiEndpoint}/referral_reminders/${reminderId}/complete`
      )
      .then((response) => {
        this.refresh();
      });
  }

  markReminderIncomplete(reminderId) {
    return api
      .put(
        `${this.props.apiEndpoint}/referral_reminders/${reminderId}/incomplete`
      )
      .then((response) => {
        this.refresh();
      });
  }

  deleteReminder(reminderId) {
    return api
      .delete(`${this.props.apiEndpoint}/referral_reminders/${reminderId}`)
      .then((response) => {
        this.refresh();
      });
  }

  unassignAgent() {
    const {
      referral: { id: referralId },
    } = this.state;
    const { apiEndpoint } = this.props;
    return api
      .delete(`${apiEndpoint}/referrals/${referralId}/assigned_agent`)
      .then((resp) => {
        FlashMessageActions.flashSuccess({
          message: 'Referral updated.',
        });
        this.refresh();
      });
  }

  handleResendAppointmentText() {
    if (window.confirm('Are you sure?')) {
      // TODO: We could add a custom rejection handler here, once we have partial rejection handling from #2954
      return api
        .post(
          `${this.props.apiEndpoint}/referrals/${this.state.referral.id}/additional_patient_texts`
        )
        .then((response) => {
          FlashMessageActions.flashSuccess({
            message: 'You have successfully sent the patient a text message',
          });
        });
    }
    return Promise.resolve();
  }

  render() {
    if (
      this.state.referral &&
      !(this.state.hideStaleContent && this.state.fetchingId)
    ) {
      return (
        <div>
          <PresentationComponent
            referral={this.state.referral}
            refresh={this.refresh}
            creatorName={this.state.creatorName}
            createdOn={this.state.createdOn}
            patient={this.state.patient}
            appointment={this.state.appointment}
            handleScheduleClick={() => this.showModal('schedule')}
            handleAssignOrScheduleClick={() =>
              this.showModal('assignOrSchedule')
            }
            handleFilesClick={() => this.showModal('file')}
            handleConfirmClick={this.handleConfirmClick}
            handlePatientConfirmClick={this.handlePatientConfirmClick}
            handleReasonForDelayClick={() => this.showModal('reasonForDelay')}
            handleAssignAgentClick={() => this.showModal('assignAgent')}
            handleUnassignAgentClick={this.unassignAgent}
            handleUpdateSpecialtyClick={() => this.showModal('updateSpecialty')}
            handleCancelClick={() => this.showModal('cancel')}
            handleNoShowClick={() => this.showModal('noshow')}
            handleRejectClick={() => this.showModal('reject')}
            handleExhaustClick={() => this.showModal('exhaust')}
            handleWithdrawClick={() => this.showModal('withdraw')}
            handleChooseClick={this.handleChooseClick}
            handleChecklistClick={() => this.showModal('checklist')}
            handleCreateIncidentalFindingsClick={() =>
              this.showModal('create-incidental-findings')
            }
            handleEditIncidentalFindingsClick={() =>
              this.showModal('edit-incidental-findings')
            }
            handleAcknowledgeIncidentalFindingsClick={
              this.acknowledgeIncidentalFindings
            }
            handleReminderClick={() => this.showModal('reminder')}
            markReminderComplete={this.markReminderComplete}
            markReminderIncomplete={this.markReminderIncomplete}
            deleteReminder={this.deleteReminder}
            deleteFileAttachmentMapping={this.deleteFileAttachmentMapping}
            handleResendAppointmentText={this.handleResendAppointmentText}
            webpageBase={this.props.webpageBase}
            serverWebpageBase={this.props.serverWebpageBase}
            apiEndpoint={this.props.apiEndpoint}
            options={this.state.options}
            editPatientPath={this.state.editPatientPath}
          />
          <Modal
            show={this.state.openModal === 'assignAgent'}
            onHide={this.hideModal}
          >
            <AssignAgentForm
              referralId={this.props.params.referralId}
              handleSuccess={this.handleSuccessfulModalAction}
              apiEndpoint={this.props.apiEndpoint}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'reasonForDelay'}
            onHide={this.hideModal}
          >
            <ReasonForDelayForm
              referralId={this.props.params.referralId}
              handleSuccess={this.handleSuccessfulModalAction}
              apiEndpoint={this.props.apiEndpoint}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'updateSpecialty'}
            onHide={this.hideModal}
          >
            <UpdateSpecialtyForm
              referralId={this.props.params.referralId}
              initialValues={{
                specialtyId: this.state.referral.specialtyId,
              }}
              handleSuccess={this.handleSuccessfulModalAction}
              apiEndpoint={this.props.apiEndpoint}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'reminder'}
            onHide={this.hideModal}
          >
            <ReferralReminderCreator
              referralId={this.props.params.referralId}
              handleSuccess={this.handleSuccessfulModalAction}
              apiEndpoint={this.props.apiEndpoint}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'withdraw'}
            onHide={this.hideModal}
          >
            <ReferralWithdrawer
              referralId={this.props.params.referralId}
              handleSuccess={this.handleSuccessfulModalAction}
              apiEndpoint={this.props.apiEndpoint}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'assignOrSchedule'}
            onHide={this.hideModal}
          >
            <QuickAssignOrSchedule
              referralId={this.props.params.referralId}
              handleSuccess={this.handleSuccessfulAssignOrSchedule}
              webpageBase={this.props.webpageBase}
              apiEndpoint={this.props.apiEndpoint}
              allowGiveTime={this.state.options.allowGiveTime}
              showProviderSearch={this.state.options.allowReplace}
              handleChooseClick={this.handleChooseClick}
            />
          </Modal>
          <Modal show={this.state.openModal === 'file'} onHide={this.hideModal}>
            <FileUploader
              referralId={this.props.params.referralId}
              handleSuccess={this.handleSuccessfulModalAction}
              apiEndpoint={this.props.apiEndpoint}
            />
          </Modal>
          {this.state.appointment && (
            <Modal
              show={this.state.openModal === 'cancel'}
              onHide={this.hideModal}
            >
              <AppointmentCanceller
                appointmentId={this.state.appointment.id}
                handleSuccess={this.handleSuccessfulModalAction}
                apiEndpoint={this.props.apiEndpoint}
              />
            </Modal>
          )}
          {this.state.referral.rejectable && (
            <RejectReferralModal
              isOpen={this.state.openModal === 'reject'}
              onClose={this.hideModal}
              referralId={this.state.referral.id}
              onSuccess={this.handleSuccessfulModalAction}
            />
          )}
          {this.state.referral.exhaustable && (
            <Modal
              show={this.state.openModal === 'exhaust'}
              onHide={this.hideModal}
            >
              <ReferralExhauster
                referralId={this.state.referral.id}
                handleSuccess={this.handleSuccessfulModalAction}
                apiEndpoint={this.props.apiEndpoint}
              />
            </Modal>
          )}
          {this.state.appointment && (
            <Modal
              show={this.state.openModal === 'noshow'}
              onHide={this.hideModal}
            >
              <AppointmentNoShower
                appointmentId={this.state.appointment.id}
                handleSuccess={this.handleSuccessfulModalAction}
                apiEndpoint={this.props.apiEndpoint}
              />
            </Modal>
          )}
          {(this.state.referral.checklist.checklistItems.length > 0 ||
            this.state.options.allowModifyChecklist) && (
            <Modal
              show={this.state.openModal === 'checklist'}
              onHide={this.hideModal}
            >
              <ReferralChecklist
                referralId={this.state.referral.id}
                apiEndpoint={this.props.apiEndpoint}
                checkable={!!this.state.options.allowCheckChecklist}
                editable={!!this.state.options.allowModifyChecklist}
                handleSuccess={this.refresh}
              />
            </Modal>
          )}
          <Modal
            show={this.state.openModal === 'choose'}
            onHide={this.hideModal}
          >
            <ChooseWarning
              referral={this.state.referral}
              webpageBase={this.props.webpageBase}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'create-incidental-findings'}
            onHide={this.hideModal}
          >
            <IncidentalFindings.New
              referralId={this.state.referral.id}
              apiEndpoint={this.props.apiEndpoint}
              handleSuccess={this.handleSuccessfulModalAction}
            />
          </Modal>
          <Modal
            show={this.state.openModal === 'edit-incidental-findings'}
            onHide={this.hideModal}
          >
            <IncidentalFindings.Edit
              referralId={this.state.referral.id}
              apiEndpoint={this.props.apiEndpoint}
              handleSuccess={this.handleSuccessfulModalAction}
            />
          </Modal>
        </div>
      );
    } else {
      return (
        <Page title="Referral Details">
          <div className="row-fluid">
            <LoadingContent />
          </div>
        </Page>
      );
    }
  }
}

function percentCompleteStringForChecklist(checklist) {
  const numTotal = checklist.checklistItems.length;
  const numCompleted = checklist.checklistItems.filter((item) => item.complete)
    .length;
  return `${Math.floor((numCompleted / numTotal) * 100)}%`;
}

const PresentationComponent = (props) => {
  const { referral, patient, appointment, apiEndpoint, options } = props;
  const { checklist } = referral;
  return (
    <div>
      <Page title="View Referral">
        {referral.enteredByGuest && (
          <div
            className="alert"
            style={{ marginTop: '0.5em', marginBottom: 0 }}
          >
            Notice: This referral was sent by a guest who does not have a
            verified preferral account.
          </div>
        )}
        <div className={styles.container}>
          <div className={styles.widget}>
            <h3 className={styles.section_header}>Referral Action Center</h3>
            {/* <div>
              <p>
                Assigned Agent:{' '}
                {referral.assignedAgent ? referral.assignedAgent.fullName : <span>None</span>}
              </p>
            </div> */}
            <div
              className={styles.action_center_container}
              data-spec-id="referral-action-center"
            >
              {props.options.showAssignedAgent && (
                <div className="is-flex" style={{ marginBottom: 12 }}>
                  {referral.assignedAgent ? (
                    <p>Assigned to: {referral.assignedAgent.name}</p>
                  ) : (
                    <p style={{ color: '#a0aec0' }}>No assigned agent</p>
                  )}
                  {props.options.allowUpdateAssignedAgent && (
                    <div style={{ marginBottom: 8 }}>
                      <button
                        type="button"
                        style={{
                          border: 'none',
                          background: 'none',
                          color: '#3182ce',
                          fontSize: '1rem',
                          borderBottom: '1px #3182ce dashed',
                          marginLeft: '0.75rem',
                          padding: 0,
                          lineHeight: 1.5,
                        }}
                        onClick={props.handleAssignAgentClick}
                      >
                        Edit
                      </button>
                      {referral.assignedAgent ? (
                        <button
                          type="button"
                          style={{
                            border: 'none',
                            background: 'none',
                            color: '#e53e3e',
                            fontSize: '1rem',
                            borderBottom: '1px #e53e3e dashed',
                            marginLeft: '0.5rem',
                            padding: 0,
                            lineHeight: 1.5,
                          }}
                          onClick={props.handleUnassignAgentClick}
                        >
                          Remove
                        </button>
                      ) : null}
                    </div>
                  )}
                </div>
              )}

              {props.options.showCreator && (
                <p>
                  Created By: {props.creatorName}{' '}
                  <span className={styles.supplementary}>
                    on {props.createdOn}
                  </span>
                </p>
              )}
              <p className="py-1">
                Status:{' '}
                <StatusBadge
                  statusSymbol={referral.statusSymbol}
                  statusName={referral.statusName}
                />
                {referral.stat && (
                  <span>
                    {' '}
                    <span className={cx(styles.stat, 'label')}>STAT</span>
                  </span>
                )}
              </p>
              {referral.reasonForDelay && (
                <p className="py-1">
                  Reason for Delay: {referral.reasonForDelay}
                </p>
              )}
              {referral.transferredToId &&
                referral.authorizedRelatedReferrals.find(
                  (r) => r.id === referral.transferredToId
                ) && (
                  <p className="py-1">
                    Transferred to{' '}
                    <Link
                      to={`${props.webpageBase}/referrals/${referral.transferredToId}`}
                    >
                      a newer referral
                    </Link>
                  </p>
                )}
              {referral.replacedById &&
                referral.authorizedRelatedReferrals.find(
                  (r) => r.id === referral.replacedById
                ) && (
                  <p className="py-1">
                    Replaced by{' '}
                    <Link
                      to={`${props.webpageBase}/referrals/${referral.replacedById}`}
                    >
                      a newer referral
                    </Link>
                  </p>
                )}
              {appointment && (
                <div>
                  <p className="py-1">Appointment: {appointment.startTime}</p>
                  <div className={styles.appointmentConfirmation}>
                    {appointment.statusSymbol === 'no_show' ||
                    appointment.statusSymbol === 'cancelled' ? (
                      <AppointmentStatusBadge
                        status={appointment.statusSymbol}
                      />
                    ) : (
                      <span>
                        <AppointmentStatusBadge
                          status={appointment.statusSymbol}
                          prefix="Office"
                        />
                        <AppointmentStatusBadge
                          status={
                            appointment.patientConfirmed
                              ? 'confirmed'
                              : 'unconfirmed'
                          }
                          prefix="Patient"
                        />
                      </span>
                    )}
                  </div>
                </div>
              )}
              <p className="py-1">
                Action Required: <span>{referral.nextStepText}</span>
              </p>
              {checklist.checklistItems.length > 0 ? (
                <p className="py-1">
                  Checklist Items:{' '}
                  <span
                    className="fake-link"
                    onClick={props.handleChecklistClick}
                  >
                    {percentCompleteStringForChecklist(checklist)}
                  </span>
                </p>
              ) : (
                props.options.allowModifyChecklist && (
                  <p className="py-1">
                    Checklist Items:{' '}
                    <span
                      className="fake-link"
                      onClick={props.handleChecklistClick}
                    >
                      create
                    </span>
                  </p>
                )
              )}
              {referral.transferredFromId &&
                referral.authorizedRelatedReferrals.find(
                  (r) => r.id === referral.transferredFromId
                ) && (
                  <p className="py-1">
                    This referral was transferred from{' '}
                    <Link
                      to={`${props.webpageBase}/referrals/${referral.transferredFromId}`}
                    >
                      a previous referral
                    </Link>
                  </p>
                )}
              {referral.replacesId &&
                referral.authorizedRelatedReferrals.find(
                  (r) => r.id === referral.replacesId
                ) && (
                  <p className="py-1">
                    This referral replaces{' '}
                    <Link
                      to={`${props.webpageBase}/referrals/${referral.replacesId}`}
                    >
                      a previous referral
                    </Link>
                  </p>
                )}

              <div className="pt-3">
                {props.options.allowGiveTime &&
                  referral.hasOrganization &&
                  referral.active && (
                    <button
                      className="btn btn-mini btn-primary"
                      onClick={props.handleAssignOrScheduleClick}
                    >
                      {referral.booked
                        ? 'Reassign/Reschedule'
                        : 'Assign/Schedule'}
                    </button>
                  )}
                {props.options.allowConfirm &&
                  appointment &&
                  appointment.status === 'Unconfirmed' && (
                    <PromiseButton
                      className="btn btn-mini btn-primary"
                      onClick={props.handleConfirmClick}
                    >
                      Confirm Appointment
                    </PromiseButton>
                  )}
                {props.options.allowPatientConfirm &&
                  appointment &&
                  appointment.patientConfirmed === false &&
                  (appointment.status === 'Confirmed' ||
                    appointment.status === 'Unconfirmed') && (
                    <PromiseButton
                      className="btn btn-mini btn-primary"
                      onClick={props.handlePatientConfirmClick}
                    >
                      Confirm Appointment for Patient
                    </PromiseButton>
                  )}
                {props.options.allowReplace &&
                  !referral.replacedById &&
                  !referral.transferredToId && (
                    <button
                      className="btn btn-mini btn-primary"
                      onClick={props.handleChooseClick}
                    >
                      {referral.hasOrganization ? 'Choose New' : 'Choose'}{' '}
                      Location/Provider
                    </button>
                  )}
                {props.options.allowTexting &&
                  appointment &&
                  appointment.status !== 'Cancelled' &&
                  appointment.status !== 'No Show' && (
                    <PromiseButton
                      className="btn btn-mini btn-primary"
                      onClick={props.handleResendAppointmentText}
                    >
                      Resend Patient Text
                    </PromiseButton>
                  )}
                {props.options.allowCancel && referral.booked && (
                  <button
                    className="btn btn-mini btn-danger"
                    onClick={props.handleCancelClick}
                  >
                    Cancel Appointment
                  </button>
                )}

                {props.options.allowCancel && referral.booked && (
                  <button
                    className="btn btn-mini btn-danger"
                    onClick={props.handleNoShowClick}
                  >
                    No Show Appointment
                  </button>
                )}

                {appointment &&
                props.options.allowComplete &&
                referral.booked ? (
                  appointment.completed ? (
                    <UncompleteAppointmentButton
                      appointmentId={appointment.id}
                      className="btn btn-mini btn-warning"
                      onSuccess={props.refresh}
                    >
                      Uncomplete Appointment
                    </UncompleteAppointmentButton>
                  ) : (
                    <CompleteAppointmentButton
                      appointmentId={appointment.id}
                      className="btn btn-mini btn-success"
                      onSuccess={props.refresh}
                    >
                      Complete Appointment
                    </CompleteAppointmentButton>
                  )
                ) : null}

                {props.options.allowReject && referral.rejectable && (
                  <button
                    className="btn btn-mini btn-danger"
                    onClick={props.handleRejectClick}
                  >
                    Reject Referral
                  </button>
                )}
                {props.options.allowWithdraw && referral.withdrawable && (
                  <button
                    className="btn btn-mini btn-danger"
                    onClick={props.handleWithdrawClick}
                  >
                    Withdraw Referral
                  </button>
                )}
                {props.options.allowExhaust && referral.exhaustable && (
                  <button
                    className="btn btn-mini btn-danger"
                    onClick={props.handleExhaustClick}
                  >
                    Exhaust Referral
                  </button>
                )}
                {props.options.allowReasonForDelay && (
                  <button
                    className="btn btn-mini btn-warning"
                    onClick={props.handleReasonForDelayClick}
                  >
                    Add Reason for Delay
                  </button>
                )}
                {props.options.allowChangeSpecialty && (
                  <button
                    className="btn btn-mini"
                    onClick={props.handleUpdateSpecialtyClick}
                  >
                    Change Specialty
                  </button>
                )}
              </div>
            </div>
            <div className={styles.to_and_from_section}>
              <div className={styles.half}>
                <ReferralProviderCard
                  senderOrReceiver="sender"
                  profileImageSrc={referral.referringProvider.profileImagePath}
                  providerName={referral.referringProvider.nameWithAppellation}
                  providerNpi={referral.referringProvider.npi}
                  specialty={referral.referringProvider.specialtyName}
                  organizationName={referral.referringOrganization.name}
                  locationName={referral.referringLocation.name}
                  locationPhone={referral.referringLocation.formattedPhone}
                  locationFax={referral.referringLocation.formattedFax}
                  mapUrl={referral.referringLocation.mapUrl}
                  fullAddress={referral.referringLocation.fullAddress}
                  id={referral.referringLocation.id}
                  linkLocations={props.options.showLocationLinks}
                  webpageBase={props.webpageBase}
                />
              </div>
              {referral.receivingLocation && (
                <div
                  className={styles.half}
                  data-spec-id="receiving-provider-card"
                >
                  {referral.receivingProvider ? (
                    <ReferralProviderCard
                      senderOrReceiver="receiver"
                      profileImageSrc={
                        referral.receivingProvider.profileImagePath
                      }
                      providerName={
                        referral.receivingProvider.nameWithAppellation
                      }
                      providerNpi={referral.receivingProvider.npi}
                      specialty={referral.specialtyName}
                      organizationName={referral.receivingOrganization.name}
                      locationName={referral.receivingLocation.name}
                      locationPhone={referral.receivingLocation.formattedPhone}
                      locationFax={referral.receivingLocation.formattedFax}
                      mapUrl={referral.receivingLocation.mapUrl}
                      locationVerifiedData={
                        referral.receivingLocation.verifiedData
                      }
                      locationFaxFirst={referral.receivingLocation.faxFirst}
                      locationCallFirst={referral.receivingLocation.callFirst}
                      hasStaffUsers={referral.receivingLocation.hasStaffUsers}
                      fullAddress={referral.receivingLocation.fullAddress}
                      id={referral.receivingLocation.id}
                      linkLocations={props.options.showLocationLinks}
                      webpageBase={props.webpageBase}
                    />
                  ) : (
                    <ReferralProviderCard
                      senderOrReceiver="receiver"
                      profileImageSrc="/assets/default.avatar.png"
                      providerName="Provider Not Chosen"
                      specialty={referral.specialtyName}
                      organizationName={referral.receivingOrganization.name}
                      locationName={referral.receivingLocation.name}
                      locationPhone={referral.receivingLocation.formattedPhone}
                      locationFax={referral.receivingLocation.formattedFax}
                      mapUrl={referral.receivingLocation.mapUrl}
                      locationVerifiedData={
                        referral.receivingLocation.verifiedData
                      }
                      locationFaxFirst={referral.receivingLocation.faxFirst}
                      locationCallFirst={referral.receivingLocation.callFirst}
                      fullAddress={referral.receivingLocation.fullAddress}
                      id={referral.receivingLocation.id}
                      linkLocations={props.options.showLocationLinks}
                      webpageBase={props.webpageBase}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div className={styles.widget}>
            <div className={styles.section}>
              <h3 className={styles.section_header}>Patient Details</h3>
              <div className={styles.section_content}>
                <div className={styles.patient_name}>
                  {patient.firstName} {patient.lastName}
                  {props.editPatientPath && (
                    <Link to={`${props.webpageBase}${props.editPatientPath}`}>
                      <span style={{ fontSize: 14 }}>
                        {' '}
                        <Icon name="pencil" />
                      </span>
                    </Link>
                  )}
                  <br />
                  {props.options.startNewReferrals && (
                    <Link
                      to={`/a/portal/referral_profiles/new?existing_patient_id=${patient.patientId}`}
                      className="btn btn-primary btn-mini"
                    >
                      Start New Referral
                    </Link>
                  )}
                </div>
                <div style={{ margin: '15px 0' }}>
                  <div>
                    Born: {patient.dob} - {patient.ageWithMonths}
                  </div>
                  <div className="flex items-center">
                    Primary Phone: {referral.formattedPrimaryPhone}
                    <div className="flex items-center ml-2">
                      (
                      <Icon
                        name={
                          referral.primaryPhoneTextable ? 'mobile' : 'phone'
                        }
                      />
                      <span className="ml-2">
                        {referral.primaryPhoneTextable ? 'mobile' : 'landline'}
                      </span>
                      )
                    </div>
                  </div>
                  {referral.formattedSecondaryPhone && (
                    <div className="flex items-center">
                      Secondary Phone: {referral.formattedSecondaryPhone}
                      <div className="flex items-center ml-2">
                        (
                        <Icon
                          name={
                            referral.secondaryPhoneTextable ? 'mobile' : 'phone'
                          }
                        />
                        <span className="ml-2">
                          {referral.secondaryPhoneTextable
                            ? 'mobile'
                            : 'landline'}
                        </span>
                        )
                      </div>
                    </div>
                  )}
                  {patient.fullAddress ? (
                    <div>Address: {patient.fullAddress}</div>
                  ) : null}
                  {patient.last4Ssn ? (
                    <div>
                      Last 4 of SSN:{' '}
                      <span className="text-gray-400">XXX-XX-</span>
                      {patient.last4Ssn}
                    </div>
                  ) : null}
                  {referral.patientDistance ? (
                    <div>
                      Distance: {referral.patientDistance.toFixed(1)} mi
                    </div>
                  ) : null}
                  <PatientCoverageDetails
                    allowInsuranceCoverageData={
                      options.allowInsuranceCoverageData
                    }
                    webpageBase={props.webpageBase}
                    patientCoverage={referral.patientCoverage}
                  />
                </div>
              </div>
            </div>

            {!!referral.referringGuest ? (
              <div className={styles.section}>
                <h3 className={styles.section_header}>
                  Referring Office Contact
                </h3>
                <div className={styles.section_content}>
                  <p style={{ margin: '0 0 0.25rem' }}>
                    <span style={{ display: 'inline-block', width: '1.25rem' }}>
                      <Icon name="user" />
                    </span>{' '}
                    {referral.referringGuest.firstName}{' '}
                    {referral.referringGuest.lastName}
                  </p>
                  <p style={{ margin: '0 0 0.25rem' }}>
                    <span style={{ display: 'inline-block', width: '1.25rem' }}>
                      <Icon name="envelope" />
                    </span>{' '}
                    {referral.referringGuest.email}
                  </p>
                </div>
              </div>
            ) : null}

            <div className={styles.section} data-spec-id="reminders-list">
              <h3 className={styles.section_header}>Reminders</h3>
              <Reminders
                reminders={referral.reminders}
                editRemindersFromAdmin={props.options.editRemindersFromAdmin}
                editRemindersFromSender={props.options.editRemindersFromSender}
                editRemindersFromReceiver={
                  props.options.editRemindersFromReceiver
                }
                markReminderComplete={props.markReminderComplete}
                markReminderIncomplete={props.markReminderIncomplete}
                deleteReminder={props.deleteReminder}
              />
              <br />
              <div className={styles.section_content}>
                {
                  <button
                    className="btn btn-mini btn-primary"
                    onClick={props.handleReminderClick}
                  >
                    Add Reminder
                  </button>
                }
              </div>
            </div>

            <div className={styles.section} data-spec-id="files-list">
              <h3 className={styles.section_header}>Files</h3>
              <div className="py-1">
                <Link
                  to={`${props.webpageBase}/referrals/${referral.id}/faxes/new`}
                >
                  <Icon name="fax" /> Send Fax
                </Link>
              </div>
              {referral.receivingOrganization &&
              referral.receivingOrganization.ppfFileUploadInstructions ? (
                <p
                  style={{ whiteSpace: 'pre-wrap' }}
                  className="px-6 py-2 text-sm"
                >
                  {referral.receivingOrganization.ppfFileUploadInstructions}
                </p>
              ) : null}
              <div className={styles.section_content}>
                {referral.files.length > 0 ? (
                  <ul>
                    {referral.files.map((file) => (
                      <li key={file.id} data-spec-id={`file${file.id}`}>
                        <ShowFile apiEndpoint={apiEndpoint} file={file} />
                        {options.showFileUploadTimes && (
                          <span className={styles.supplementary}>
                            {' '}
                            ({file.uploadedAt})
                          </span>
                        )}{' '}
                        <button
                          type="button"
                          title="Remove this File"
                          className="inline-block"
                          onClick={() =>
                            props.deleteFileAttachmentMapping(file.id)
                          }
                          data-spec-class="remove-file"
                        >
                          <Icon name="bin" />
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div>
                    {'No files uploaded'}
                    <br />
                  </div>
                )}
                <br />
                <button
                  onClick={props.handleFilesClick}
                  className="btn btn-mini btn-primary"
                >
                  Upload Files
                </button>
              </div>
            </div>
            <div className={styles.section} data-spec-id="incidental-finding">
              <h3 className={styles.section_header}>
                Referral Report / Consult Notes
              </h3>
              {options.allowEditIncidentalFindings &&
                referral.incidentalFinding && (
                  <span className={styles.supplemental_section_header}>
                    {referral.incidentalFinding.lastRevisionAcknowledged ? (
                      <span> (Acknowledged by referring office)</span>
                    ) : (
                      <span> (Not yet acknowledged by referring office)</span>
                    )}
                  </span>
                )}
              <div className={styles.section_content}>
                {referral.incidentalFinding ? (
                  <div>
                    <p>{referral.incidentalFinding.memo}</p>
                    {referral.incidentalFinding.files.length > 0 ? (
                      <ul>
                        {referral.incidentalFinding.files.map((file) => (
                          <li key={file.id} data-spec-id={`file${file.id}`}>
                            <ShowFile apiEndpoint={apiEndpoint} file={file} />
                            &nbsp;
                            {options.allowEditIncidentalFindings && (
                              <span
                                title="Remove this File"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                  props.deleteFileAttachmentMapping(file.id)
                                }
                                data-spec-class="remove-file"
                              >
                                <Icon name="bin" />
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div>(No attached files)</div>
                    )}
                    {options.allowEditIncidentalFindings ? (
                      <div>
                        <br />
                        <button
                          onClick={props.handleEditIncidentalFindingsClick}
                          className="btn btn-mini btn-primary"
                        >
                          Edit Report
                        </button>
                      </div>
                    ) : (
                      <div>
                        <br />
                        {referral.incidentalFinding.lastRevisionAcknowledged ? (
                          <span className="label label-info">Acknowledged</span>
                        ) : (
                          <PromiseButton
                            onClick={
                              props.handleAcknowledgeIncidentalFindingsClick
                            }
                            className="btn btn-mini btn-primary"
                          >
                            Acknowledge Findings
                          </PromiseButton>
                        )}
                      </div>
                    )}
                  </div>
                ) : options.allowEditIncidentalFindings ? (
                  <button
                    onClick={props.handleCreateIncidentalFindingsClick}
                    className="btn btn-mini btn-primary"
                  >
                    Create Report
                  </button>
                ) : (
                  <p>None reported</p>
                )}
              </div>
            </div>
            {referral.hasQuestionnaire ? (
              <ReferralQuestionnaire
                questionnaire={referral.referralQuestionnaire}
                pdfUrl={
                  props.serverWebpageBase
                    ? `${props.serverWebpageBase}/referrals/${referral.id}/questionnaire_response.pdf`
                    : null
                }
              />
            ) : null}
            {referral.additionalInfo && (
              <div className={styles.section}>
                <h3 className={styles.section_header}>
                  Additional Information
                </h3>
                <div className={styles.section_content}>
                  <p>{referral.additionalInfo}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles.container} data-spec-id="referral-events">
          <div className={styles.widget}>
            <div className={styles.section}>
              <h3 className={styles.section_header}>Activity</h3>
              {renderRelatedReferrals(
                referral.id,
                referral.authorizedRelatedReferrals,
                props.webpageBase,
                props.apiEndpoint
              )}
              <br />
              {/* <CommentForm
                referralId={referral.id}
                handleSuccess={props.refresh}
                apiEndpoint={props.apiEndpoint}
                render={renderCommentForm}
              /> */}
              <CommentForm referralId={referral.id} onSuccess={props.refresh} />
            </div>
          </div>
        </div>
      </Page>
    </div>
  );
};

const renderRelatedReferrals = (
  mainReferralId,
  relatedReferrals,
  webpageBase,
  apiEndpoint
) => (
  <div>
    {relatedReferrals.map((relatedReferral) => (
      <div key={relatedReferral.id} className={styles.RelatedReferral}>
        <div className={styles.RelatedReferral_header}>
          Referral to: <span>{relatedReferral.receivingName}</span> entered by{' '}
          <Tooltip
            id={`${relatedReferral.id}-enteredBy`}
            renderTooltip={() => (
              <span>{relatedReferral.createdBy.organizationName}</span>
            )}
          >
            <span>{relatedReferral.createdBy.name}</span>
          </Tooltip>
          <span className={styles.RelatedReferral_timestamp}>
            {moment(relatedReferral.createdAt).calendar()}
          </span>
          {relatedReferral.id !== mainReferralId && (
            <Link to={`${webpageBase}/referrals/${relatedReferral.id}`}>
              <Icon name="redo2" tip="View this referral" />
            </Link>
          )}
        </div>
        <div
          className={cx(styles.RelatedReferral_events_container, {
            [styles.is_current_referral]: relatedReferral.id === mainReferralId,
          })}
        >
          {relatedReferral.events.map((event) => (
            <ReferralEvent key={event.id} event={event} />
          ))}
        </div>
      </div>
    ))}
  </div>
);

PresentationComponent.propTypes = {
  refresh: PropTypes.func.isRequired,
  apiEndpoint: PropTypes.string.isRequired,
  webpageBase: PropTypes.string.isRequired,
  editPatientPath: PropTypes.string,
};

export default Show;
